import { render, staticRenderFns } from "./PprRptStts.vue?vue&type=template&id=768b1ce2&"
import script from "./PprRptStts.vue?vue&type=script&lang=js&"
export * from "./PprRptStts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports